module.exports = __webpack_public_path__ + "img/edu-assist.b9f17bbf.svg";